export default __webpack_public_path__ + "static/media/times-solid.ea7c95d7.svg";